import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import axios from 'axios';

import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

axios.defaults.baseURL = process.env.REACT_APP_ADMIN_API_URL;

ReactDOM.render(
  <BrowserRouter>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </BrowserRouter>,
  document.getElementById('root'),
);

// Setup based on this tutorial https://create-react-app.dev/docs/making-a-progressive-web-app/
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration: ServiceWorkerRegistration) => {
    registration.waiting?.postMessage({ type: 'SKIP_WAITING' });

    // We skip posting a notification for now
    /*
    const dispatch = useDispatch();

    const message = Message.info('common.update_available', false)
      .withAction('common.refresh', () => {
        registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
      })
      .withTranslatedText();

    dispatch(notificationActions.addMessage(message)); */
  },
});

// reload once when the new Service Worker starts activating
let refreshing = false;
navigator?.serviceWorker?.addEventListener('controllerchange', function () {
  if (refreshing) return;
  refreshing = true;
  window.location.reload();
});
